import React from "react";
// import { Link } from "react-router-dom";

function KnowMore5() {
    return (
        <div className="select-none  w-full ">
            <div className="flex relative pt-2 mb-10">
                <img
                    className="select-none hidden lg:block md:block h-28 w-auto lg:h-96 lg:w-auto md:h-44 md:w-auto md:pt-6 md:pl-6 lg:pt-6 lg:pl-6"
                    src="https://i.ibb.co/3kqHs45/Know-More4-1.png"
                    alt="Working of Modernvate"
                />
                <div className="select-none mt-2 md:mt-4 lg:mt-4 md:mx-6 lg:mx-14 p-2 bg-slate-100 bg-opacity-40 border-4 border-white/60 lg:rounded-tr-[5rem] lg:rounded-bl-[5rem] md:rounded-tr-[3rem] md:rounded-bl-[3rem]">
                    <div className="flex items-center px-2 rounded-br-3xl shadow-md bg-cyan-200 bg-opacity-30 lg:w-1/2 md:w-1/2 w-3/4">
                        <img src="https://i.ibb.co/8c1CKVN/Know-More4-2.png" className="h-14" alt="" />
                        <p className="select-none md:ml-2 text-xs md:text-sm lg:ml-4 lg:text-xl text-red-500 font-extrabold lg:tracking-wide">
                            OTHER SERVICES
                        </p>
                    </div>
                    <div className="select-none text-[12px] p-2 md:text-xs lg:text-xl text-grey md:p-3 lg:p-5 lg:tracking-wider">
                        <span className="text-orange font-bold">To Do List</span> - An
                        interactive and easy place to store and keep all your tasks at one
                        place group of students can see their common tasks and collectively
                        work on those tasks.
                    </div>
                    <div className="select-none text-[12px] p-2 md:text-xs lg:text-xl text-grey md:p-3 lg:p-5 lg:tracking-wider">
                        <span className="text-[#EFA451] font-bold">Calendar </span>- An user
                        friendly place where one can plan their daily as well as monthly
                        activity safely, securily.
                    </div>
                </div>
            </div>


            <footer className="lg:m-4 bg-[#C5D4F2] md:p-3 sm:p-2 rounded-3xl">
                <div className="md:flex md:justify-between">
                    <div>
                        <img src="https://i.ibb.co/NNgmSDY/footer-img.png" className="hidden lg:block md:block lg:px-8 md:pr-5 lg:h-60 lg:w-96 md:h-48 md:w-96" alt="footer-img" />
                    </div>
                    <div className="lg:h-full lg:w-full md:w-full md:h-full">
                        <img src="https://i.ibb.co/R9cKZRv/Group-27.png" className="lg:w-64 md:w-48 w-32 px-3" alt="logo"></img>
                        <div className="lg:pb-1 md:pb-4 mx-auto">
                            <div className="select-none lg:text-lg md:text-sm text-[11px] text-gray-500 px-5">
                                502 GPM, Bandra Kherwadi East
                                <p className="select-none lg:text-lg md:text-sm text-[11spx] text-gray-500">Mumbai -400001</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-3 gap-4 text-center justify-between pt-2 lg:pt-0">
                            <div>
                                <ul className="text-gray-600 lg:text-lg md:text-xs md:leading-5 text-[11px]">
                                    <li>
                                        <a href="/about" className="hover:underline">About Us</a>
                                    </li>
                                    <li >
                                        <a href="https://modernsolnhub.com/page/contact-h8km3" className="select-none hover:underline">Contact
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://modernsolnhub.com/page/internship-r6npio" className="hover:underline">Internship</a>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <ul className="text-gray-600 lg:text-lg md:text-xs md:leading-5 text-[11px]">
                                    <li >
                                        <a href="https://modernsolnhub.com/page/microservices-certification-qw546f" className="hover:underline">Certification</a>                                   </li>
                                    <li >
                                        <a href="/Dashboard" className="hover:underline">Home</a>
                                    </li>
                                    <li>
                                        <a href="https://modernsolnhub.com/" className="hover:underline">ModernSolHub</a>                                   </li>
                                </ul>
                            </div>
                            <div>
                                <ul className="text-gray-600 lg:text-lg md:text-xs md:leading-5 text-[11px]">
                                    <li>
                                        <a href="/know-more" className="hover:underline">Know More</a>
                                    </li>
                                    <li >
                                        <a href="https://modernsolnhub.com/page/our-leaders-h8km3" className="hover:underline">Leaders</a>
                                    </li>
                                    <li>
                                        <a href="https://modernsolnhub.com/page/student-to-smart-it-professional-masterclass" className="hover:underline">Course</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* <hr className=" border-gray-200 sm:mx-auto lg:mb-2" /> */}
                    <div className=" mb-2 flex gap-2 sm:mt-3 lg:pr-5 md:pr-5 md:w-96 w-32 pb-2 h-8 pt-2 justify-center mx-auto">
                        <a href="https://www.instagram.com/haresh_kurade_729/" className="lg:mt-[11.5rem] md:mt-[9.5rem]">
                            <img
                                alt="instagram"
                                src="https://i.ibb.co/BwmjsLB/instagram.png"
                                className=" transition ease-in-out   hover:scale-75  duration-1"
                            ></img>
                            <span className="sr-only">instagram page</span>
                        </a>
                        <a href="https://www.facebook.com/haresh.kurade.729/" className="lg:mt-[11.5rem] md:mt-[9.5rem]">
                            <img
                                alt="Facebook"
                                src="https://i.ibb.co/c8nkskK/facebook.png"
                                className="transition ease-in-out   hover:scale-75  duration-10"
                            ></img>
                            <span className="sr-only">facebook page</span>
                        </a>
                        <a href="https://web.telegram.org/k/#@Haresh_Kurade_729" className="lg:mt-[11.5rem] md:mt-[9.5rem]">
                            <img
                                alt="telegram"
                                src="https://i.ibb.co/T8YTjmF/telegram.png"
                                className="transition ease-in-out   hover:scale-75  duration-10"
                            ></img>
                            <span className="sr-only">telegram page</span>
                        </a>
                        <a href="http://www.linkedin.com/in/haresh-kurade-22a04b241" className="lg:mt-[11.5rem] md:mt-[9.5rem]">
                            <img
                                alt="in"
                                src="https://i.ibb.co/YZBFK1h/in.png"
                                className="transition ease-in-out   hover:scale-75  duration-10"
                            ></img>
                            <span className="sr-only">in page</span>
                        </a>
                        <a href="https://twitter.com/" className="lg:mt-[11.5rem] md:mt-[9.5rem]">
                            <img
                                alt="twitter"
                                src="https://i.ibb.co/d0mY9Zp/twitter.png"
                                className="transition ease-in-out hover:scale-75  duration-10"
                            ></img>
                            <span className="sr-only">twitter page</span>
                    
                        </a>
                    </div>
                </div>
            </footer>
            </div>
    );
}

export default KnowMore5;